import * as React from "react";
import { EventCardSectionItem } from "../EventCardSectionItem";
export const TeamsScore = (props) => 
//to-do: scoreboards
React.createElement(React.Fragment, null,
    React.createElement(EventCardSectionItem, { content: props.score1, className: `rj-ev-list__${props.componentPrefix}__score rj-ev-list__${props.componentPrefix}__score-home`, componentPrefix: props.componentPrefix }),
    React.createElement(EventCardSectionItem, { content: props.score2, className: `rj-ev-list__${props.componentPrefix}__score rj-ev-list__${props.componentPrefix}__score-away`, componentPrefix: props.componentPrefix }));
//# sourceMappingURL=TeamsScore.js.map